export function HiddenFocusElement() {
  return <input tabIndex="0" hidden />;
}
